import { mainWeb, mainWebResource } from '../../../config/net'

const index = `${mainWeb}/recharge/message`
const detail = {
  url: `${mainWeb}${mainWebResource}`,
  method: 'getonlinemallpageinfo'
}

export default {
  index,
  detail
}



// WEBPACK FOOTER //
// ./src/model/rechage/message/resource-url.js